// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fAO-","index":"styles_index__30Ayb"};